import { CoreModel } from '../core/core.model';
import { IconModel } from '../icon/icon.model';
export class BreadCrumbModel extends CoreModel {
/**
 * Description here ...
 */
links: any[];
/**
 * Description here ...
 */
icon: IconModel;
/**
 * @hidden 
 * It is the constructor for the button component. It takes the required string values to create the button object
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function BreadCrumbModel_tsickle_Closure_declarations() {
/**
 * Description here ...
 * @type {?}
 */
BreadCrumbModel.prototype.links;
/**
 * Description here ...
 * @type {?}
 */
BreadCrumbModel.prototype.icon;
}

